<section class="animate__animated animate__fadeInRight p5-5"  >

  <div class="row" >
    <div class="col container-flex-unique" [ngClass]="{'margin-diameter': diameter}">
      <img src="./assets/img/loading.gif"  alt="loading" [ngStyle]="getDiameter()">
      <h3 class="title-loading" > {{ title }}  </h3>
      <h3 class="title-loading" > {{ title2 }}  </h3>
    </div>
  </div>

</section>
